import ProfileCard from '../components/ProfileCard';
import { KoobContainer, KoobCard } from '@koob/ui';

/** The profile page's content; each app renders the page header itself. */
export default function ProfileLayout({ user, children }) {
  return (
    <KoobContainer>
      <KoobCard padding="none">
        <div className="p-6">
          <ProfileCard user={user} />
        </div>

        <div className="p-6 flex-col space-y-5">{children}</div>
      </KoobCard>
    </KoobContainer>
  );
}
